<template>
  <div class="las-bottom-panel">
    <div>
      <quick-add-attributes v-if="!hideQuickAddAttributes" :viewOnly="viewOnly"></quick-add-attributes>
      <target-definition
        :enableNot="lasActions"
        :class="[sizeClass]"
        :viewOnly="viewOnly"
      ></target-definition>
    </div>
    <div class="las-bottom-panel__footer">
      <bottom-pane-sizer
        class="las-bottom-panel__footer__sizer"
        :current-size="currentBottomPaneSize"
        @new-size="changeBottomPaneSize">
      </bottom-pane-sizer>
      <definition-actions
        class="las-bottom-panel__footer__actions"
        :class="{'viewOnly': viewOnly}"
        :enableSaving="enableSaving"
        :allowDownloadBtn="false"
        :viewOnly="viewOnly"
        :targetData="targetData"
        :lasActions="lasActions"
        :xandrActions="xandrActions">
      </definition-actions>
    </div>
  </div>

</template>

<script>
import TargetDefinition from '../targetDefinition'
import QuickAddAttributes from '../quickAddAttributes/QuickAddAttributes.vue'
import BottomPaneSizer from '../bottomPaneSizer/BottomPaneSizer.vue'
import DefinitionActions from '../definitionActions/DefinitionActions.vue'

/**
 * TODO need to get the quick options from something that is in the state of the store....
 * TODO need to make sure that the buttons work as needed
 * TODO need to make the CSS on the buttons work as well...
 * TODO need to create a component for each of the types of workbenches that we are going to have
 */

export default {
  components: {
    TargetDefinition,
    QuickAddAttributes,
    BottomPaneSizer,
    DefinitionActions,
  },
  props: {
    targetData: {
      type: Object
    },
    viewOnly: {
      type: Boolean,
      default: false
    },
    lasActions: {
      type: Boolean
    },
    xandrActions: {
      type: Boolean
    },
  },
  data () {
    return {
      currentBottomPaneSize: 'medium'
    }
  },
  computed: {
    sizeClass () {
      return `is-${this.currentBottomPaneSize}`
    },
    enableSaving () {
      return this.$store.state.workbench.enableSaving
    },
    hideQuickAddAttributes () {
      return this.xandrActions
    },
  },
  methods: {
    changeBottomPaneSize (size) {
      this.currentBottomPaneSize = size
    }
  }
}
</script>

<style lang="scss">
.las-bottom-panel{
  .target-definition {
    &.is-small {
      height: 0;
      overflow: hidden;
    }

    &.is-medium {
      height: rem(180);
    }

    &.is-large {
      height: rem(360);
    }
  }
  &__footer {
    display: flex;
    margin: 10px;

    &__sizer {
      flex: 2 1 auto;
      display: flex;
      justify-content: center;
    }

    &__actions {
      flex: 5 1 auto;
      display: flex;
      justify-content: flex-end;
      button {
        margin-left: 10px;
        margin-right: 10px;
      }
    }
  }
}
.viewOnly {
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// BottomPanel.vue?52ff8e56